import { fetcher } from '@commenda/utils';

export const removeBillingQuoteLine = async (
  quoteId: string,
  lineId: string,
  expectedEditVersion?: number
) => {
  const response = await fetcher(
    `commenda-billing/quotes/${quoteId}/lines/${lineId}${expectedEditVersion == null ? '' : `?expectedEditVersion=${expectedEditVersion}`}`,
    {
      method: 'DELETE',
    }
  );

  return response;
};
